module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M3-de7e4b8a14d6b211324ea7a190edb563.png";